import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  saveDatosDelViajeExterior
} from "../../../../../redux/actions/certificadoCobertura";
import DatosDelViaje from "./DatosDelViaje";

const initialValues = {
  fechaViajeDesde: null,
  fechaViajeHasta: null,
  destino: "",
  coberturaSaludExterior: "CardinalAssistance",
};

const DatosDelViajeContainer = ({ handleNext, fromBread }) => {
  const dispatch = useDispatch();

  const datosDelViaje = useSelector(
    (state) => state.certificadoCobertura.postCertificadoCobertura.datosDelViaje
  );

  const fechaLimite = useSelector((state) => state.certificadoCobertura.fechaLimiteViajeAlExterior.data);

  const [formModel, setFormModel] = useState(null);

  const handleSubmit = (values) => {
    dispatch(saveDatosDelViajeExterior(values));
    handleNext("SelecciónDeEmpleados");
  };

  useEffect(() => {
    setFormModel({
      ...initialValues,
      fechaViajeDesde:
        datosDelViaje?.fechaViajeDesde || initialValues.fechaViajeDesde,
      fechaViajeHasta:
        datosDelViaje?.fechaViajeHasta || initialValues.fechaViajeHasta,
      destino: datosDelViaje?.destino || initialValues.destino,
      coberturaSaludExterior:
        datosDelViaje?.coberturaSaludExterior ||
        initialValues.coberturaSaludExterior,
    });
  }, []);

  return (
    <DatosDelViaje handleSubmit={handleSubmit} formModel={formModel} fechaMinima={fechaLimite} />
  );
};

export default DatosDelViajeContainer;
